import { graphql } from '@api/generated';
import { getClient } from '@api/client';
import { UserWrapupStatus } from '@api/generated/graphql';

export const getUserWrapupStatusTimeQuery = graphql(`
  query userWrapupStatus($userId: ID!) {
    userWrapupStatus(userId: $userId) {
      startedTimestamp
      elapsedTime
      remainingTime
    }
  }
`);

export const fetchUserWrapupStatusTime = async ({
  userId,
}: {
  userId: string;
}): Promise<UserWrapupStatus | null> => {
  const { data, error } = await getClient().query({
    query: getUserWrapupStatusTimeQuery,
    variables: {
      userId,
    },
    fetchPolicy: 'network-only',
  });

  if (error) {
    throw new Error(error.message);
  }

  return data?.userWrapupStatus ?? null;
};
